export class AgentInfo {
  id: string;
  name: string;
  referralCode: string;
  customerId: string;
  campaignId: string;
  kycType: number;
  constructor() {
    this.id = '';
    this.name = '';
    this.referralCode = '';
    this.customerId = '';
    this.campaignId = '';
    this.kycType = 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/agent.ts